import { makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) => ({
  row: {
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(3.5),
  },
  title: {
    width: 245,
    padding: 5,
    fontSize: 14,
    letterSpacing: 0.15,
    color: 'rgb(0 0 0 / 54%)',
  },
  desc: {
    width: 'calc(100% - 285px)',
    borderBottom: '1px solid #E0E0E0',
    padding: 5,
    color: 'rgb(0 0 0 / 87%)',
  },
  gridPaper: {
    height: '100%',
  },
  tabsPanel: {
    width: '60%',
  },
  descGreen: {
    color: '#4caf50',
    marginRight: theme.spacing(2.5),
  },
}));
